<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb
      :title="$vuetify.lang.t('$vuetify.DASHBOARD.MONTHLY_PASSES')"
      :breadcrumbs="[
        {
          text: '',
          disabled: true
        }
      ]"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <phone-select
                  :initial-country-code="'+372'"
                  :initial-phone-number="selectedPhoneNumber"
                />
              </v-col>
              <v-col cols="12" sm="2">
                <v-menu
                  v-model="validFromPicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="datePickerFormat(selectedValidFrom)"
                      :label="$vuetify.lang.t('$vuetify.VALID_FROM')"
                      :placeholder="$vuetify.lang.t('$vuetify.VALID_FROM')"
                      append-icon="mdi-calendar"
                      readonly
                      outlined
                      hide-details
                      clearable
                      dense
                      v-bind="attrs"
                      @click:clear="validFrom = null"
                      @click:append="validFromPicker = !validFromPicker"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="selectedValidFrom"
                    @input="validFromPicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="2">
                <v-menu
                  v-model="validToPicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="datePickerFormat(selectedValidTo)"
                      :label="$vuetify.lang.t('$vuetify.VALID_TO')"
                      :placeholder="$vuetify.lang.t('$vuetify.VALID_TO')"
                      append-icon="mdi-calendar"
                      readonly
                      outlined
                      hide-details
                      clearable
                      dense
                      v-bind="attrs"
                      @click:clear="selectedValidTo = null"
                      @click:append="validToPicker = !validToPicker"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="selectedValidTo"
                    @input="validToPicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  v-model.number="selectedMonthlyCost"
                  :label="
                    this.$vuetify.lang.t(
                      '$vuetify.EDIT_PLACE.MONTHLY.MONTHLY_COST'
                    )
                  "
                  hide-details
                  outlined
                  dense
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  v-model="selectedInfo"
                  :label="this.$vuetify.lang.t('$vuetify.COMMENTS')"
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn
                  v-if="!currentlySelectedMonthlyPass"
                  color="success"
                  text
                  small
                  @click="addMonthlyPass()"
                >
                  <v-icon class="mr-2">mdi-plus</v-icon>
                  {{ $vuetify.lang.t('$vuetify.ADD') }}
                </v-btn>
                <v-icon
                  v-if="currentlySelectedMonthlyPass"
                  class="mr-2"
                  @click="cancelEditing()"
                >
                  mdi-close
                </v-icon>
                <v-btn
                  v-if="currentlySelectedMonthlyPass"
                  color="success"
                  text
                  small
                  @click="updateMonthlyPass()"
                >
                  {{ $vuetify.lang.t('$vuetify.EDIT') }}
                </v-btn>
              </v-col>
            </v-row>
            <v-data-table
              :items="activeMonthlyPasses"
              :headers="headers"
              hide-default-footer
              :no-data-text="
                $vuetify.lang.t(
                  '$vuetify.EDIT_PLACE.MONTHLY.NO_ACTIVE_MONTHLY_PASSES'
                )
              "
              :items-per-page="-1"
            >
              <template v-slot:top>
                <div class="body-2 secondary--text ml-3">
                  {{ activeMonthlyPasses.length }}
                  {{
                    activeMonthlyPasses.length === 1
                      ? $vuetify.lang.t('$vuetify.ACTIVE')
                      : $vuetify.lang.t('$vuetify.ACTIVE_PLURAL')
                  }}
                </div>
              </template>
              <template
                v-for="(header, i) in headers"
                v-slot:[`header.${header.value}`]
              >
                <span v-if="header.i18n" :key="i">
                  {{ $vuetify.lang.t(`$vuetify.${header.i18n}`) }}
                </span>
                <span v-else-if="!header.i18n && header.text" :key="i">
                  {{ header.text }}
                </span>
              </template>
              <!-- <template v-slot:item.ParkingSessionId="props">
                <td>{{ props.item.ParkingSessionId }}</td>
              </template>
              <template v-slot:item.PlaceAddress="props">
                <td>{{ props.item.PlaceAddress }}</td>
              </template>
              <template v-slot:item.PlaceName="props">
                <td>{{ props.item.PlaceName }}</td>
              </template>
              <template v-slot:item.CarNumber="props">
                <td>{{ props.item.CarNumber }}</td>
              </template> -->
              <template v-slot:item.ValidFrom="props">
                <td>{{ dateEE(props.item.ValidFrom, '.', false) }}</td>
              </template>
              <template v-slot:item.ValidTo="props">
                <td>
                  {{
                    !props.item.ValidTo ||
                    props.item.ValidTo === '0001-01-01T00:00:00Z'
                      ? '∞'
                      : dateEE(props.item.ValidTo, '.', false)
                  }}
                </td>
              </template>
              <template v-slot:item.MonthlyCostInCents="props">
                <td>
                  {{ props.item.MonthlyCostInCents / 100 }}
                  {{ props.item.Currency }}
                </td>
              </template>
              <template v-slot:item.actions="props">
                <td>
                  <div class="d-flex align-center">
                    <v-btn icon small @click="editMonthlyPass(props.item)">
                      <v-icon small color="primary">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon small @click="deleteMonthlyPass(props.item)">
                      <v-icon small color="error">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <v-data-table
              :items="expiredMonthlyPasses"
              :headers="headers"
              hide-default-footer
              :no-data-text="
                $vuetify.lang.t(
                  '$vuetify.EDIT_PLACE.MONTHLY.NO_EXPIRED_MONTHLY_PASSES'
                )
              "
              :items-per-page="-1"
            >
              <template v-slot:top>
                <div class="body-2 secondary--text ml-3">
                  {{ expiredMonthlyPasses.length }}
                  {{ $vuetify.lang.t('$vuetify.EXPIRED') }}
                </div>
              </template>
              <template
                v-for="(header, i) in headers"
                v-slot:[`header.${header.value}`]
              >
                <span v-if="header.i18n" :key="i">
                  {{ $vuetify.lang.t(`$vuetify.${header.i18n}`) }}
                </span>
                <span v-else-if="!header.i18n && header.text" :key="i">
                  {{ header.text }}
                </span>
              </template>
              <template v-slot:item.ValidFrom="props">
                <td>{{ dateEE(props.item.ValidFrom, '.', false) }}</td>
              </template>
              <template v-slot:item.ValidTo="props">
                <td>
                  {{
                    props.item.ValidTo === '0001-01-01T00:00:00Z'
                      ? '∞'
                      : dateEE(props.item.ValidTo, '.', false)
                  }}
                </td>
              </template>
              <template v-slot:item.MonthlyCostInCents="props">
                <td>{{ props.item.MonthlyCostInCents / 100 }}</td>
              </template>
              <template v-slot:item.actions="props">
                <td>
                  <div class="d-flex align-center">
                    <v-btn icon small @click="editMonthlyPass(props.item)">
                      <v-icon small color="primary">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon small @click="deleteMonthlyPass(props.item)">
                      <v-icon small color="error">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { EventBus } from '@/event-bus.js'
import formatDate from '@/mixins/formatDate'

export default {
  name: 'MonthlyPasses',
  components: {
    PhoneSelect: () =>
      import(
        /* webpackChunkName: "PhoneSelect" */ '@/components/commonComponents/PhoneSelect'
      )
  },
  mixins: [formatDate],
  props: {
    id: String
  },
  data() {
    return {
      headers: [
        {
          text: this.$vuetify.lang.t('$vuetify.CLIENT_ID'),
          i18n: 'CLIENT_ID',
          value: 'ClientId',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t('$vuetify.PHONE_NUMBER'),
          i18n: 'PHONE_NUMBER',
          value: 'PhoneNumber',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t('$vuetify.EMAIL'),
          i18n: 'EMAIL',
          value: 'Email',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t('$vuetify.VALID_FROM'),
          i18n: 'VALID_FROM',
          value: 'ValidFrom',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t('$vuetify.VALID_TO'),
          i18n: 'VALID_TO',
          value: 'ValidTo',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t('$vuetify.CLIENT_ACTIVE_CAR_NUMBER'),
          i18n: 'CLIENT_ACTIVE_CAR_NUMBER',
          value: 'ClientActiveLicensePlate',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t('$vuetify.CAR_NUMBER'),
          i18n: 'CAR_NUMBER',
          value: 'LicensePlate',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.EDIT_PLACE.MONTHLY.MONTHLY_COST'
          ),
          i18n: 'EDIT_PLACE.MONTHLY.MONTHLY_COST',
          value: 'MonthlyCostInCents',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t('$vuetify.COMMENTS'),
          i18n: 'COMMENTS',
          value: 'Info',
          guarded: false
        },

        { text: '', value: 'actions' }
      ],
      activeMonthlyPasses: [],
      expiredMonthlyPasses: [],
      selectedPhoneNumber: '',
      validFromPicker: false,
      selectedValidFrom: '',
      validToPicker: false,
      selectedValidTo: '',
      selectedMonthlyCost: '',
      selectedInfo: '',
      isValidPhoneNumber: false,
      diallingCode: '',
      currentlySelectedMonthlyPass: null
    }
  },
  created() {
    // this.selectedValidTo = this.dateEE(new Date())
    // this.selectedValidTo = this.formatDate(new Date())
    const zeroDate = new Date('0001-01-01T00:00:00Z')
    this.$store.dispatch('places/getMonthlyPasses', this.id).then(response => {
      response.forEach(element => {
        element.ValidFrom = new Date(element.ValidFrom)
        element.ValidTo = new Date(element.ValidTo)

        if (element.ValidFrom.getTime() === zeroDate.getTime()) {
          element.ValidFrom = undefined
        }
        if (element.ValidTo.getTime() === zeroDate.getTime()) {
          element.ValidTo = undefined
        }

        if (element.ValidTo) {
          element.ValidTo.setDate(element.ValidTo.getDate() - 1)
        }
        if (!element.ValidTo || element.ValidTo > new Date()) {
          this.activeMonthlyPasses.push(element)
        } else {
          this.expiredMonthlyPasses.push(element)
        }
      })
    })
    EventBus.$on('phoneNumberChanged', item => {
      this.selectedPhoneNumber = item.event
      this.isValidPhoneNumber = item.valid
    })
    EventBus.$on('phoneDiallingCodeChanged', item => {
      this.diallingCode = item.event.dialling_code
      this.isValidPhoneNumber = item.valid
    })
    this.selectedValidFrom = this.formatDate(new Date())
  },
  methods: {
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    datePickerFormat(dateValue) {
      const date = new Date(dateValue)
      return dateValue
        ? `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
        : ''
    },
    addMonthlyPass() {
      this.$store
        .dispatch('places/postMonthlyPass', {
          placeId: this.id,
          data: {
            AppId: 1,
            PhoneNumber: this.selectedPhoneNumber,
            MonthlyCostInCents: this.selectedMonthlyCost * 100,
            ValidFrom: new Date(this.selectedValidFrom),
            ValidTo: new Date(this.selectedValidTo),
            Info: this.selectedInfo
          }
        })
        .then(newPass => {
          this.activeMonthlyPasses.push(newPass)
          this.$store.commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: this.$vuetify.lang.t('$vuetify.EDIT_PLACE.MONTHLY.ADDED')
            },
            { root: true }
          )
          this.cancelEditing()
        })
    },
    editMonthlyPass(item) {
      // const zeroDate = new Date('0001-01-01T00:00:00Z')
      this.currentlySelectedMonthlyPass = item
      this.selectedPhoneNumber = item.PhoneNumber
      this.selectedMonthlyCost = item.MonthlyCostInCents / 100
      this.selectedValidFrom = this.formatDate(new Date(item.ValidFrom))
      if (!item.ValidTo) {
        this.selectedValidTo = ''
      } else {
        this.selectedValidTo = this.formatDate(new Date(item.ValidTo))
      }
      this.selectedInfo = item.Info
    },
    updateMonthlyPass() {
      const item = this.currentlySelectedMonthlyPass
      if (!item.AppId) {
        item.AppId = 1
      }
      item.ValidFrom = new Date(this.selectedValidFrom)
      item.ValidTo = this.selectedValidTo
        ? new Date(this.selectedValidTo)
        : undefined
      item.MonthlyCostInCents = this.selectedMonthlyCost * 100
      item.PhoneNumber = this.selectedPhoneNumber
      item.Info = this.selectedInfo
      this.$store.dispatch('places/putMonthlyPass', item).then(() => {
        if (!item.ValidTo || item.ValidTo > new Date()) {
          const existingWhitelist = this.activeMonthlyPasses.find(
            pass => pass.Id === item.Id
          )
          Object.assign(existingWhitelist, item)
        } else {
          const existingWhitelist = this.expiredMonthlyPasses.find(
            pass => pass.Id === item.Id
          )
          if (!item.ValidTo) {
            item.ValidTo = this.formatDate(new Date('0001-01-01T00:00:00Z'))
          }
          Object.assign(existingWhitelist, item)
        }
        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'success',
            message: this.$vuetify.lang.t('$vuetify.EDIT_PLACE.MONTHLY.UPDATED')
          },
          { root: true }
        )
        this.cancelEditing()
      })
    },
    cancelEditing() {
      this.currentlySelectedMonthlyPass = null
      this.selectedPhoneNumber = ''
      this.selectedValidFrom = this.formatDate(new Date())
      this.selectedValidTo = ''
      this.selectedMonthlyCost = ''
      this.selectedInfo = ''
    },
    deleteMonthlyPass(item) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(option => {
        if (option === true) {
          this.$store.dispatch('places/deleteMonthlyPass', item).then(() => {
            const activePassesIndex = this.activeMonthlyPasses.findIndex(
              pass => pass.Id === item.Id
            )
            const expiredPassesIndex = this.expiredMonthlyPasses.findIndex(
              pass => pass.Id === item.Id
            )
            this.activeMonthlyPasses.splice(activePassesIndex, 1)
            this.expiredMonthlyPasses.splice(expiredPassesIndex, 1)
          })
        }
      })
    }
  }
}
</script>
